var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "second-row" }, [
    _c("div", { staticClass: "time" }, [
      _c("div", { staticClass: "take-off col-sm-4" }, [
        _c("div", { staticClass: "icon" }, [
          _vm.modulo === "services"
            ? _c("i", { staticClass: "soap-icon-plane-right yellow-color" })
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", [
          _vm.modulo === "services"
            ? _c("span", { staticClass: "skin-color-srvcs" }, [
                _vm._v(_vm._s(_vm.takeoff[_vm.getCurrentLocale])),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _vm._v(
            "\n                " +
              _vm._s(_vm._f("moment")(_vm.flight.depDT)) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "landing col-sm-4" }, [
        _c("div", { staticClass: "icon" }, [
          _vm.modulo === "services"
            ? _c("i", { staticClass: "soap-icon-plane-right yellow-color" })
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", [
          _vm.modulo === "services"
            ? _c("span", { staticClass: "skin-color-srvcs" }, [
                _vm._v(_vm._s(_vm.landing[_vm.getCurrentLocale])),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _vm._v(
            "\n                " +
              _vm._s(_vm._f("moment")(_vm.flight.desDT)) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "total-time col-sm-4" }, [
        _c("div", { staticClass: "icon" }, [
          _vm.modulo === "services"
            ? _c("i", { staticClass: "soap-icon-clock yellow-color" })
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", [
          _vm.modulo === "services"
            ? _c("span", { staticClass: "skin-color-srvcs" }, [
                _vm._v(_vm._s(_vm.totaltime[_vm.getCurrentLocale])),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _vm._v(
            "\n                " +
              _vm._s(_vm._f("durationFlight")(_vm.flight.dur)) +
              "\n            "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.flightdirection === "outward"
      ? _c("div", { staticClass: "action" }, [
          _vm.getBookingFlightIdSelectedOutward !== _vm.flight.id
            ? _c(
                "a",
                {
                  staticClass: "button btn-small full-width xgreen",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.flightSelected({
                        flight: _vm.flight,
                        type: "outward",
                        modulo: _vm.modulo,
                      })
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.selectbookedflight[_vm.getCurrentLocale]) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.getBookingFlightIdSelectedOutward === _vm.flight.id
            ? _c(
                "a",
                { staticClass: "button btn-small full-width sundairsrvcs" },
                [_vm._v(_vm._s(_vm.selectbookedflight[_vm.getCurrentLocale]))]
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.flightdirection === "return"
      ? _c("div", { staticClass: "action" }, [
          _vm.getBookingFlightIdSelectedReturn !== _vm.flight.id
            ? _c(
                "a",
                {
                  staticClass: "button btn-small full-width xgreen",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.flightSelected({
                        flight: _vm.flight,
                        type: "return",
                        modulo: _vm.modulo,
                      })
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.selectbookedflight[_vm.getCurrentLocale]) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.getBookingFlightIdSelectedReturn === _vm.flight.id
            ? _c(
                "a",
                { staticClass: "button btn-small full-width sundairsrvcs" },
                [_vm._v(_vm._s(_vm.selectbookedflight[_vm.getCurrentLocale]))]
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }